import { render, staticRenderFns } from "./DeviceDetailInfo.vue?vue&type=template&id=59a15f2c&scoped=true&"
import script from "./DeviceDetailInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailInfo.vue?vue&type=style&index=0&id=59a15f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a15f2c",
  null
  
)

export default component.exports